// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var Expln_React_Modal = require("@expln/utils/src/main/react-components/Expln_React_Modal.bs.js");
var MM_wrk_FindParens = require("../worker/MM_wrk_FindParens.bs.js");
var Expln_React_Column = require("@expln/utils/src/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("@expln/utils/src/main/Expln_React_common.bs.js");
var Expln_utils_common = require("@expln/utils/src/main/Expln_utils_common.bs.js");
var Expln_utils_promise = require("@expln/utils/src/main/Expln_utils_promise.bs.js");
var Button = require("@mui/material/Button").default;
var Expln_utils_jsonParse = require("@expln/utils/src/main/Expln_utils_jsonParse.bs.js");
var TextField = require("@mui/material/TextField").default;
var Sync = require("@mui/icons-material/Sync").default;
var IconButton = require("@mui/material/IconButton").default;

function createDefaultSettings(param) {
  return {
          parens: "( ) [ ] { }",
          parensIsValid: true,
          types: [
            "wff",
            "term",
            "setvar",
            "class"
          ],
          colors: [
            "#4363d8",
            "#000000",
            "#e6194B",
            "#f032e6"
          ]
        };
}

function settingsSaveToLocStor(settings, key) {
  localStorage.setItem(key, Expln_utils_common.stringify(settings));
}

function settingsReadFromLocStor(key) {
  var settingsLocStorStr = localStorage.getItem(key);
  if (settingsLocStorStr === null) {
    return ;
  }
  var parseResult = Expln_utils_jsonParse.parseObj(settingsLocStorStr, (function (d) {
          return {
                  parens: Expln_utils_jsonParse.str(d, "parens"),
                  parensIsValid: Expln_utils_jsonParse.bool(d, "parensIsValid"),
                  types: Expln_utils_jsonParse.arr(d, "types", Expln_utils_jsonParse.asStr),
                  colors: Expln_utils_jsonParse.arr(d, "colors", Expln_utils_jsonParse.asStr)
                };
        }));
  if (parseResult.TAG === /* Ok */0) {
    return parseResult._0;
  }
  
}

function getParens(st) {
  return MM_parser.getSpaceSeparatedValuesAsArray(st.parens);
}

function getCorrectedTypesAndColors(st) {
  var correctedTypes = [];
  var correctedColors = [];
  st.types.map(function (typ, i) {
            return [
                    typ.trim(),
                    Caml_array.get(st.colors, i).trim()
                  ];
          }).filter(function (param) {
          if (param[0] !== "") {
            return param[1] !== "";
          } else {
            return false;
          }
        }).forEach(function (param) {
        correctedTypes.push(param[0]);
        correctedColors.push(param[1]);
      });
  return [
          correctedTypes,
          correctedColors
        ];
}

function getTypeColors(st) {
  var match = getCorrectedTypesAndColors(st);
  var colors = match[1];
  return Belt_MapString.fromArray(match[0].map(function (typ, i) {
                  return [
                          typ,
                          Caml_array.get(colors, i)
                        ];
                }));
}

function setParens(st, str) {
  return {
          parens: str,
          parensIsValid: st.parensIsValid,
          types: st.types,
          colors: st.colors
        };
}

function correctAndValidate(st) {
  var parensArr = MM_parser.getSpaceSeparatedValuesAsArray(st.parens);
  var match = getCorrectedTypesAndColors(st);
  return {
          parens: parensArr.join(" "),
          parensIsValid: parensArr.length % 2 === 0,
          types: match[0],
          colors: match[1]
        };
}

function eqState(st1, st2) {
  if (Caml_obj.equal(MM_parser.getSpaceSeparatedValuesAsArray(st1.parens), MM_parser.getSpaceSeparatedValuesAsArray(st2.parens)) && Caml_obj.equal(st1.types, st2.types)) {
    return Caml_obj.equal(st1.colors, st2.colors);
  } else {
    return false;
  }
}

function MM_cmp_settings(Props) {
  var modalRef = Props.modalRef;
  var ctx = Props.ctx;
  var initialSettings = Props.initialSettings;
  var onChange = Props.onChange;
  var match = React.useState(function () {
        return initialSettings;
      });
  var setPrevState = match[1];
  var prevState = match[0];
  var match$1 = React.useState(function () {
        return initialSettings;
      });
  var setStatePriv = match$1[1];
  var state = match$1[0];
  var setState = function (update) {
    Curry._1(setStatePriv, (function (prev) {
            var $$new = Curry._1(update, prev);
            settingsSaveToLocStor($$new, "settings");
            return $$new;
          }));
  };
  var onParensChange = function (newParens) {
    setState(function (st) {
          var st$1 = setParens(st, newParens);
          if (st$1.parensIsValid) {
            return st$1;
          } else {
            return correctAndValidate(st$1);
          }
        });
  };
  return React.createElement(Expln_React_Column.make, {
              spacing: 3,
              style: {
                margin: "30px"
              },
              children: null
            }, React.createElement(Expln_React_Row.make, {
                  alignItems: "center",
                  children: null
                }, React.createElement(TextField, {
                      value: state.parens,
                      label: "Parentheses",
                      size: "small",
                      style: {
                        width: "400px"
                      },
                      onChange: (function (param) {
                          return Expln_React_common.evt2str(onParensChange, param);
                        }),
                      title: "Parentheses are used to speed up finding of substitutions",
                      error: !state.parensIsValid
                    }), React.createElement("span", {
                      title: "Determine parentheses from the loaded MM file"
                    }, React.createElement(IconButton, {
                          onClick: (function (param) {
                              Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                          return MM_react_common.rndProgress("Searching parentheses", 0);
                                        })), (function (modalId) {
                                      MM_wrk_FindParens.beginFindParens(ctx, (function (pct) {
                                              Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                                      return MM_react_common.rndProgress("Searching parentheses", pct);
                                                    }));
                                            }), (function (parens) {
                                              onParensChange(parens);
                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                            }));
                                    }));
                            }),
                          children: React.createElement(Sync, {})
                        }))), eqState(prevState, state) ? null : React.createElement(Expln_React_Row.make, {
                    spacing: 3,
                    children: null
                  }, React.createElement(Button, {
                        onClick: (function (param) {
                            var st = correctAndValidate(state);
                            setState(function (param) {
                                  return st;
                                });
                            if (st.parensIsValid) {
                              Curry._1(setPrevState, (function (param) {
                                      return st;
                                    }));
                              return Curry._1(onChange, st);
                            }
                            
                          }),
                        variant: "contained",
                        disabled: !state.parensIsValid,
                        children: "Apply changes"
                      }), React.createElement(Button, {
                        onClick: (function (param) {
                            setState(function (param) {
                                  return prevState;
                                });
                          }),
                        children: "Discard changes"
                      })));
}

var make = MM_cmp_settings;

exports.createDefaultSettings = createDefaultSettings;
exports.settingsReadFromLocStor = settingsReadFromLocStor;
exports.getParens = getParens;
exports.getTypeColors = getTypeColors;
exports.make = make;
/* react Not a pure module */
